import { useMemo } from 'react'
import { differenceInHours } from 'date-fns'

import { buildDate } from 'app/utils/dates'
import { ItemApi } from 'appTypes/items'
import { CartFormValues } from 'appTypes/orders'

export const useIsRentalBeyondMaxTime = (
  selectedProduct: ItemApi,
  values: CartFormValues,
  currentOrderStartDate: string | undefined,
  rentedFromStr: string,
  isProlonging: boolean,
): boolean => {
  return useMemo(() => {
    const MAX = selectedProduct?.maximumRentalTime

    if (values.returnAt && MAX) {
      let rentedFrom = buildDate(values.startDate, values.pickupAt)

      if (isProlonging) {
        const rentedFromForCurrentOrder = currentOrderStartDate ? currentOrderStartDate : rentedFromStr
        const date = new Date(rentedFromForCurrentOrder.split('T')[0])
        const time = rentedFromForCurrentOrder.split('T')[1].split(':')[0]

        rentedFrom = buildDate(date, time)
      }

      const rentedTo = buildDate(values.endDate, values.returnAt)

      const diff = differenceInHours(rentedTo, rentedFrom)
      return diff > MAX
    }

    return false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.startDate, values.endDate, values.pickupAt, values.returnAt])
}
